const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPythonLibraryLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.812,
    height: 58,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#a29d86",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-186.329 59.726 3.185 1.16v3.742l-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#e9e9ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(564.377 -156.012)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-189.56 60.903v3.743l3.231-1.177v-3.743z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#353564",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(564.377 -156.012)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 64.646 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#afafde",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(564.377 -156.012)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      fill: "#f7f7f4",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(564.377 -156.012)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-186.376 62.062v3.743l3.232-1.177v-3.743z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(564.377 -156.012)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159v3.743l-3.185-1.16z",
    style: {
      fill: "#efeeea",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(564.377 -156.012)scale(2.92733)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#a29d86",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-186.329 59.726 3.185 1.16v3.742l-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#e9e9ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(573.74 -163.673)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-189.56 60.903v3.743l3.231-1.177v-3.743z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#353564",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(573.74 -163.673)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 64.646 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#afafde",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(573.74 -163.673)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      fill: "#f7f7f4",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(573.74 -163.673)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-186.376 62.062v3.743l3.232-1.177v-3.743z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(573.74 -163.673)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159v3.743l-3.185-1.16z",
    style: {
      fill: "#efeeea",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(573.74 -163.673)scale(2.92733)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#a29d86",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-186.329 59.726 3.185 1.16v3.742l-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#e9e9ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(555.014 -141.542)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-189.56 60.903v3.743l3.231-1.177v-3.743z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#353564",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(555.014 -141.542)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 64.646 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#afafde",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(555.014 -141.542)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      fill: "#f7f7f4",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(555.014 -141.542)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-186.376 62.062v3.743l3.232-1.177v-3.743z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(555.014 -141.542)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159v3.743l-3.185-1.16z",
    style: {
      fill: "#efeeea",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(555.014 -141.542)scale(2.92733)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#a29d86",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-186.329 59.726 3.185 1.16v3.742l-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#e9e9ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(564.377 -138.137)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-189.56 60.903v3.743l3.231-1.177v-3.743z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#353564",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(564.377 -138.137)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 64.646 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#afafde",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(564.377 -138.137)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      fill: "#f7f7f4",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(564.377 -138.137)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-186.376 62.062v3.743l3.232-1.177v-3.743z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(564.377 -138.137)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159v3.743l-3.185-1.16z",
    style: {
      fill: "#efeeea",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(564.377 -138.137)scale(2.92733)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#a29d86",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-186.329 59.726 3.185 1.16v3.742l-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#e9e9ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(564.377 -149.203)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-189.56 60.903v3.743l3.231-1.177v-3.743z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#353564",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(564.377 -149.203)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 64.646 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#afafde",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(564.377 -149.203)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      fill: "#f7f7f4",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(564.377 -149.203)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-186.376 62.062v3.743l3.232-1.177v-3.743z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(564.377 -149.203)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159v3.743l-3.185-1.16z",
    style: {
      fill: "#efeeea",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(564.377 -149.203)scale(2.92733)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#a29d86",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-186.329 59.726 3.185 1.16v3.742l-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#e9e9ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(601.83 -144.947)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-189.56 60.903v3.743l3.231-1.177v-3.743z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#353564",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(601.83 -144.947)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 64.646 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#afafde",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(601.83 -144.947)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      fill: "#f7f7f4",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(601.83 -144.947)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-186.376 62.062v3.743l3.232-1.177v-3.743z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(601.83 -144.947)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159v3.743l-3.185-1.16z",
    style: {
      fill: "#efeeea",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(601.83 -144.947)scale(2.92733)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1683.66 -513.275)scale(.65177)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#a29d86",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-186.329 59.726 3.185 1.16v3.742l-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#e9e9ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(3492.218 570.342)scale(4.49135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-189.56 60.903v3.743l3.231-1.177v-3.743z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#353564",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(3492.218 570.342)scale(4.49135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 64.646 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#afafde",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(3492.218 570.342)scale(4.49135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      fill: "#f7f7f4",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(3492.218 570.342)scale(4.49135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-186.376 62.062v3.743l3.232-1.177v-3.743z",
    style: {
      fill: "#ffd242",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(3492.218 570.342)scale(4.49135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159v3.743l-3.185-1.16z",
    style: {
      fill: "#efeeea",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(3492.218 570.342)scale(4.49135)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 2835.218,
    cy: 1823.899,
    r: 2.967,
    style: {
      fill: "#fff",
      fillOpacity: 1
    },
    transform: "skewY(-20)scale(.9397 1)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#a29d86",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-186.329 59.726 3.185 1.16v3.742l-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#e9e9ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(583.104 -138.137)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-189.56 60.903v3.743l3.231-1.177v-3.743z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#353564",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(583.104 -138.137)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 64.646 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#afafde",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(583.104 -138.137)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      fill: "#f7f7f4",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(583.104 -138.137)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-186.376 62.062v3.743l3.232-1.177v-3.743z",
    style: {
      fill: "#ffd242",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(583.104 -138.137)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159v3.743l-3.185-1.16z",
    style: {
      fill: "#efeeea",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(583.104 -138.137)scale(2.92733)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#a29d86",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-186.329 59.726 3.185 1.16v3.742l-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#e9e9ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(573.74 -134.732)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-189.56 60.903v3.743l3.231-1.177v-3.743z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#353564",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(573.74 -134.732)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 64.646 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#afafde",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(573.74 -134.732)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      fill: "#f7f7f4",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(573.74 -134.732)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-186.376 62.062v3.743l3.232-1.177v-3.743z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(573.74 -134.732)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159v3.743l-3.185-1.16z",
    style: {
      fill: "#efeeea",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(573.74 -134.732)scale(2.92733)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#a29d86",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-186.329 59.726 3.185 1.16v3.742l-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#e9e9ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(601.83 -156.012)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-189.56 60.903v3.743l3.231-1.177v-3.743z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#353564",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(601.83 -156.012)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 64.646 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#afafde",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(601.83 -156.012)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      fill: "#f7f7f4",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(601.83 -156.012)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-186.376 62.062v3.743l3.232-1.177v-3.743z",
    style: {
      fill: "#ffd242",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(601.83 -156.012)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159v3.743l-3.185-1.16z",
    style: {
      fill: "#efeeea",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(601.83 -156.012)scale(2.92733)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#a29d86",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-186.329 59.726 3.185 1.16v3.742l-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#e9e9ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(601.83 -167.078)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-189.56 60.903v3.743l3.231-1.177v-3.743z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#353564",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(601.83 -167.078)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 64.646 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#afafde",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(601.83 -167.078)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      fill: "#ffc91d",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(601.83 -167.078)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-186.376 62.062v3.743l3.232-1.177v-3.743z",
    style: {
      fill: "#ffd242",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(601.83 -167.078)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159v3.743l-3.185-1.16z",
    style: {
      fill: "#efeeea",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(601.83 -167.078)scale(2.92733)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#a29d86",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-186.329 59.726 3.185 1.16v3.742l-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#e9e9ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(592.467 -152.608)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-189.56 60.903v3.743l3.231-1.177v-3.743z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#353564",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(592.467 -152.608)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 64.646 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#afafde",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(592.467 -152.608)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      fill: "#f7f7f4",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(592.467 -152.608)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-186.376 62.062v3.743l3.232-1.177v-3.743z",
    style: {
      fill: "#ffd242",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(592.467 -152.608)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159v3.743l-3.185-1.16z",
    style: {
      fill: "#efeeea",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(592.467 -152.608)scale(2.92733)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#a29d86",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-186.329 59.726 3.185 1.16v3.742l-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#e9e9ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(592.467 -163.673)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-189.56 60.903v3.743l3.231-1.177v-3.743z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#353564",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(592.467 -163.673)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 64.646 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#afafde",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(592.467 -163.673)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      fill: "#f7f7f4",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(592.467 -163.673)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-186.376 62.062v3.743l3.232-1.177v-3.743z",
    style: {
      fill: "#3775a9",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(592.467 -163.673)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159v3.743l-3.185-1.16z",
    style: {
      fill: "#efeeea",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(592.467 -163.673)scale(2.92733)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#a29d86",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-186.329 59.726 3.185 1.16v3.742l-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#e9e9ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(592.467 -174.739)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-189.56 60.903v3.743l3.231-1.177v-3.743z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#353564",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(592.467 -174.739)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 64.646 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#afafde",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(592.467 -174.739)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      fill: "#2f6491",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(592.467 -174.739)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-186.376 62.062v3.743l3.232-1.177v-3.743z",
    style: {
      fill: "#3775a9",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(592.467 -174.739)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159v3.743l-3.185-1.16z",
    style: {
      fill: "#efeeea",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(592.467 -174.739)scale(2.92733)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#a29d86",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-186.329 59.726 3.185 1.16v3.742l-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#e9e9ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(583.104 -149.203)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-189.56 60.903v3.743l3.231-1.177v-3.743z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#353564",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(583.104 -149.203)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 64.646 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#afafde",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(583.104 -149.203)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      fill: "#f7f7f4",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(583.104 -149.203)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-186.376 62.062v3.743l3.232-1.177v-3.743z",
    style: {
      fill: "#ffd242",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(583.104 -149.203)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159v3.743l-3.185-1.16z",
    style: {
      fill: "#efeeea",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(583.104 -149.203)scale(2.92733)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#a29d86",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-186.329 59.726 3.185 1.16v3.742l-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#e9e9ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(583.104 -160.268)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-189.56 60.903v3.743l3.231-1.177v-3.743z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#353564",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(583.104 -160.268)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 64.646 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#afafde",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(583.104 -160.268)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      fill: "#f7f7f4",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(583.104 -160.268)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-186.376 62.062v3.743l3.232-1.177v-3.743z",
    style: {
      fill: "#3775a9",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(583.104 -160.268)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159v3.743l-3.185-1.16z",
    style: {
      fill: "#efeeea",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(583.104 -160.268)scale(2.92733)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#a29d86",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-186.329 59.726 3.185 1.16v3.742l-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#e9e9ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(573.74 -145.798)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-189.56 60.903v3.743l3.231-1.177v-3.743z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#353564",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(573.74 -145.798)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 64.646 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#afafde",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(573.74 -145.798)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      fill: "#f7f7f4",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(573.74 -145.798)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-186.376 62.062v3.743l3.232-1.177v-3.743z",
    style: {
      fill: "#3775a9",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(573.74 -145.798)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159v3.743l-3.185-1.16z",
    style: {
      fill: "#2f6491",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(573.74 -145.798)scale(2.92733)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#a29d86",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-186.329 59.726 3.185 1.16v3.742l-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#e9e9ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(573.74 -156.864)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-189.56 60.903v3.743l3.231-1.177v-3.743z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#353564",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(573.74 -156.864)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 64.646 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#afafde",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(573.74 -156.864)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      fill: "#2f6491",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(573.74 -156.864)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-186.376 62.062v3.743l3.232-1.177v-3.743z",
    style: {
      fill: "#3775a9",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(573.74 -156.864)scale(2.92733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159v3.743l-3.185-1.16z",
    style: {
      fill: "#2f6491",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(573.74 -156.864)scale(2.92733)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1683.66 -513.275)scale(.65177)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#a29d86",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-186.329 59.726 3.185 1.16v3.742l-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#e9e9ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(3477.852 524.633)scale(4.49135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-189.56 60.903v3.743l3.231-1.177v-3.743z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#353564",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(3477.852 524.633)scale(4.49135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 64.646 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#afafde",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(3477.852 524.633)scale(4.49135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159 3.232-1.177-3.185-1.159z",
    style: {
      fill: "#2f6491",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(3477.852 524.633)scale(4.49135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-186.376 62.062v3.743l3.232-1.177v-3.743z",
    style: {
      fill: "#3775a9",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(3477.852 524.633)scale(4.49135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-189.56 60.903 3.184 1.159v3.743l-3.185-1.16z",
    style: {
      fill: "#2f6491",
      fillOpacity: 1,
      stroke: "#ccc",
      strokeWidth: 0.07269443,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "translate(3477.852 524.633)scale(4.49135)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 2816.017,
    cy: 1772.922,
    r: 2.967,
    style: {
      fill: "#fff",
      fillOpacity: 1
    },
    transform: "skewY(-20)scale(.9397 1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPythonLibraryLogo);
export default __webpack_public_path__ + "static/media/python_library_logo.8998e9d19286f665777eef2603835326.svg";
export { ForwardRef as ReactComponent };